import { render, staticRenderFns } from "./CeisaMasterCustomerUpdate.vue?vue&type=template&id=1565207b&scoped=true&"
import script from "./CeisaMasterCustomerUpdate.vue?vue&type=script&lang=js&"
export * from "./CeisaMasterCustomerUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CeisaMasterCustomerUpdate.vue?vue&type=style&index=0&id=1565207b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565207b",
  null
  
)

export default component.exports